<template>
	<main>
		<!-- Row Style -->
		<h3 class="text-primary mb-4"><strong>Berita Populer</strong></h3>
		<news-popular :data="popularNews" />
		
	</main>
</template>
<script>
import NewsPopular from './components/NewsPopular.vue'
import { mapState } from 'vuex'

export default {
  components: {
    NewsPopular
  },
  computed: {
    ...mapState('news', ['popularNews'])
  },
  methods: {
    getNews () {
      this.$vs.loading()

      this.$store.dispatch('news/getData')
        .then(() => {
          this.$vs.loading.close()
          this.$store.commit('news/SET_POPULAR', 3)
        })
        .catch(e => {
          this.$vs.loading.close()
          if (e.response) console.error(e.response)
          this.$vs.notify({
            title: 'Oops',
            text: e.response.data.message,
            color: 'warning',
            position: 'top-right'
          })

          return false
        })
    }
  },
  mounted () {
    this.getNews()
  }
}
</script>